// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
import { appendParameters } from '../../Core/Utils';
class GeognoSISTileImage extends ol.source.TileImage {

    constructor(options) {
        super(options);
        this.setTileUrlFunction(this.geognosisTileUrlFunction.bind(this));
        this.sessionId = options.sessionId;
        this.overlay = options.overlay;
        this.photometricInterpretation = options.photometricInterpretation;
        this.overlay.on('themeChanged', (eventArgs) => {
            this.clear();
            this.changed();
            return true;
        });
    }
    geognosisTileUrlFunction (tileCoord, pixelRatio, projection) {
        var tileGrid = this.getTileGrid();
        if (tileGrid === null) {
            tileGrid = this.getTileGridForProjection(projection);
        }

        if (tileGrid.getResolutions().length <= tileCoord[0]) {
            return undefined;
        }

        var tileExtent = tileGrid.getTileCoordExtent(tileCoord);
        var tileSize = [...tileGrid.getTileSize(tileCoord[0])];
        if (pixelRatio !== 1) {
            tileSize[0] = (tileSize[0] * pixelRatio + 0.5) | 0;
            tileSize[1] = (tileSize[1] * pixelRatio + 0.5) | 0;
        }

        var imageUrl = this.overlay.getImageUrl();
        var params = {
            'bbox': tileExtent.join(','),
            'uniqueParam': performance.now(),
            'tw': tileSize[0],
            'th': tileSize[1]
        };
        imageUrl = appendParameters(imageUrl, params);

        return imageUrl;
    }
}

export default GeognoSISTileImage;

